export default class AddClass {
  constructor() {
    this.activeClass = 'is-active';
    this.triggerOffsetFromBottom = 0.2;
    this.targets = document.querySelectorAll('.js-add_class');

    if (this.targets.length > 0) {
      this.init();
    }
  }

  init() {
    this.observeTargets();
  }

  observeTargets() {
    if (!('IntersectionObserver' in window)) {
      this.targets.forEach((el) => this.addActiveClass(el));
      return;
    }

    const rootMarginBottom = `-${Math.floor(this.triggerOffsetFromBottom * 100)}%`;
    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const el = entry.target;
          currentObserver.unobserve(el);
          this.addActiveClass(el);
        });
      },
      {
        root: null,
        rootMargin: `0px 0px ${rootMarginBottom} 0px`,
        threshold: 0
      }
    );

    this.targets.forEach((el) => observer.observe(el));
  }

  addActiveClass(el) {
    el.classList.add(this.activeClass);
  }
}
